import { ReactNode, type FunctionComponent } from 'react';
import classes from './ProgramPageHeader.module.css';
import cx from 'clsx';
import { useTenantConfig } from '@/contexts/TenantConfig';
import { VisuallyHidden } from '@mantine/core';
import Link from 'next/link';

export interface ProgramPageHeaderProps {
  className?: string;
  centerSection?: ReactNode;
  rightSection?: ReactNode;
}

const ProgramPageHeader: FunctionComponent<ProgramPageHeaderProps> = ({
  className,
  centerSection,
  rightSection,
}) => {
  const { name } = useTenantConfig();

  return (
    <div className={cx(classes.root, className)}>
      <h1 className={classes.title}>
        {/* We use CSS image replacement for the logo, rather than an <Image/> tag, so that
            the image can be sourced from the same set of variables as the rest of the theme
            in brand.css.

            TODO: After CRE-3317 lands it would be more viable to source the config from
              JavaScript-land and render an image tag here.
          */}
        <Link href="/" className={classes.logo} title="Home">
          <VisuallyHidden>{name}</VisuallyHidden>
        </Link>
      </h1>

      {centerSection && (
        <div className={classes.centerSection}>{centerSection}</div>
      )}

      {rightSection && (
        <aside className={classes.rightSection}>{rightSection}</aside>
      )}
    </div>
  );
};

export default ProgramPageHeader;
